<template>
    <div id="menuComponent">
        <div class="menuComponent-inner">
            <div class="wz-row">
                <div class="left-sidebar sidebar">
                    <div class="sidebar-inner">
                        <ul class="menus nav">
                            <li class="menu-item" v-for="(menu,key) in menus" v-if="products[menu.text_id]"
                                v-scroll-to="{el: '#menu-'+key, offset: -80,}">
                                <a :href="'#menu-'+key" v-bind:class="{active: key === 0}">{{menu.name }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="main-sidebar sidebar">
                    <div class="sidebar-inner">
                        <div class="search-area wiz-visible">
                            <img src="../assets/images/search.png" alt="">
                            <input type="text" :placeholder="$t('menu.search_text')" autocomplete="off" v-on:input="$emit('updatesearch', $event.target.value)">
                        </div>
                        <div class="products-area">
                            <div class="groupProducts" v-for="(menu,key) in menus" v-bind:id="'menu-'+key" v-if="products[menu.text_id] && filterproduct(products[menu.text_id]).length > 0">
                                <div class="menuName">
                                    <h3>{{menu.name}}</h3>
                                </div>
                                <div class="productItems">
                                    <div class="productItem" v-for="product in filterproduct(products[menu.text_id])"
                                         v-on:click="openModalProduct(product,-1,false)">
                                        <div class="productItem-inner">
                                            <div class="productImage" v-if="product.image_url">
                                                <img :src="product.image_url || imageDefault" alt=""
                                                     @onerror="product.image_url = imageDefault">
                                            </div>
                                            <div class="productInfo">
                                                <h3 class="productName" v-html="product.name"></h3>
                                                <p class="productDesc" v-html="product.description" v-if="product.description"></p>
                                                <p class="productPrice">{{product.ta_price | formatPrice}}</p>
                                                <span class="productButton"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-sidebar sidebar">
                    <div class="sidebar-inner">
                      <div class="cartItems" v-if="cart.ordersItem.length">
                        <div class="item" v-if="item" v-for="(item,index) in cart.ordersItem">
                          <div class="name"
                               @click.prevent="openModalProduct(item.product,index,item.order)">

                            <div class="itemQuantity"><span>{{ item.order.Quantity }}x</span></div>
                            <div class="itemInfo">
                              <p class="itemName">{{ item.order.Item_Name }}</p>
                              <p>Price: {{ item.order.Price }}đ</p>
                              <div class="options">
                                <div class="opItem" v-for="(op,key) in item.order.options">

                                  <template v-if="typeof op.options === 'string'">
                                    {{ op.name }} : {{ op.options }}
                                  </template>
                                  <template v-else>

                                    <template v-if="op.max === 1 && op.min === 1">
                                      <template v-for="val in op.options">
                                        <p v-if="val && val.quantity">{{ op.name }} : <span class="opVal">{{ val.name }} </span>
                                        </p>
                                      </template>
                                    </template>

                                    <template v-else>
                                      <p>{{ op.name }} : </p>
                                      <template v-for="val in op.options">
                                        <p v-if="val && val.quantity"> + <span class="opVal">{{ val.name }}: {{ val.quantity }}
                                                      <template
                                                        v-if="val.ta_price">x {{ val.ta_price }}đ</template></span></p>
                                      </template>
                                    </template>

                                  </template>
                                </div>
                              </div>
                              <p class="note" v-if="item.order.Note">Note: <em>{{item.order.Note}}</em></p>
                            </div>
                          </div>
                          <div class="price">
                            {{ ((item.order.Price + item.order.plusPrice) * item.order.Quantity)  | formatPrice }}
                          </div>
                          <span class="deleteItem" v-on:click="deleteCartItem(index)"><img src="../assets/images/delete.png"
                                                                                           alt="Delete"></span>
                        </div>
                      </div>
                        <div class="cartItemsTotal">
                            <p>{{ $t('menu.total_n_items', {n: this.$options.filters.countTotalItems(this.cart) }) }}</p>
                            <p>{{cart | totalPrice}}</p>
                        </div>
                        <div class="totalPrice">
                            <div class="totalText">
                                <p>{{ $t('menu.total') }}</p>
                                <p>{{cart | totalPrice}}</p>
                            </div>
                            <div class="viewCartBtn">
                                <button v-bind:class="{'disable': cart.ordersItem.length < 1}"
                                        v-on:click="gotoCheckout">
                                  {{ $t('menu.place_order') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mobile_cart">
                <button type="button" v-on:click="gotoCheckout">
                    <div class="content_button">
                        <div class="col">{{ $t('menu.n_items', {n: this.$options.filters.countTotalItems(this.cart) }) }}</div>
                        <div class="col">{{ $t('menu.place_order') }}</div>
                        <div class="col">
                            {{cart | totalPrice}}
                        </div>
                    </div>
                </button>
            </div>
        </div>

        <modal-product v-if="modalProduct.active"
                       :order="modalProduct.orderItem"
                       :product="modalProduct.product"
                       @close="modalProduct.active = false"
                       :activeId="modalProduct.activeId"
                       :lang="lang"
                       @updateCart="updateCart">

            <span v-on:click="modalProduct.active = false" class="closeModal"><img src="../assets/images/close.png" alt=""></span>
        </modal-product>

        <modal v-if="showModal"
               class="modal-confirm-login"
               :lang="lang"
               @close="showModal = false">
            <h2 slot="header">{{ $t('menu.checkout') }}</h2>
            <template slot="body">
                <p>{{ $t('menu.you_must_be_logged_in_to_checkout') }}</p>
                <div class="action">
                    <a v-bind:href="$foodbookConfig.loginpage" class="btn">
                      <span v-html="$t('menu.SIGN_IN')"></span></a>

                    <a v-bind:href="$foodbookConfig.loginpage" class="btn">
                      <span v-html="$t('menu.REGISTER')"></span></a>
                </div>
            </template>
        </modal>
        <!-- modal-->
    </div>
</template>

<script>
    import _ from 'lodash'
    import Modal from './Modal.vue'
    export default {
        name: 'Menu',
        components: {
            Modal
        },
        props: ['search','lang'],
        data () {
            this.$i18n.locale = this.lang || 'en';
            sessionStorage.setItem('locale', this.$i18n.locale);
            return {
                locale: this.lang || 'en',
                //Order
                cart: this.$cart,
                //Products
                products: [],
                //Menus
                menus: [],
                //Thong tin modal product
                modalProduct:{
                    active: false,
                    activeId:0,
                    product: null,
                    orderItem:null
                },
                //modal
                showModal: false,
                modalBooking:false,
                imageDefault:this.$foodbookConfig.imageDefault,
            };
        },
      async created(){

          await this.getProducts(this.$foodbookConfig.pos_id);

          window.addEventListener('scroll', this.handleScroll);
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        filters: {
            //Loc san pham duoc active
            filterProductsActive:  (products,menus) => {
                return products.filter(product => {
                    let productActive = true;
                    let menu = _.find(menus,['text_id', product.type_id]);
                    if(product.status.toUpperCase() === 'DEACTIVE'){
                        productActive = false;
                    }
                  if (menu && menu.active) {
                    productActive = true;
                  }
                  return productActive;
                })
            },
            filterMenusActive: (menus)=> {
                return menus.filter(item_type => {
                    return (item_type.active === 1)
                })
            },
            //Nhom cac san pham cung category
            groupMenu: function (value) {
                if (!value) return [];
                let result = _.chain(value)
                    .groupBy("type_id")
                    .value();
                return result;
            },

            //Lay Ten cua menu theo key
            getMenuName(value, menus) {
                let menu = _.find(menus, {text_id: value});
                if (menu) {
                    return menu.name;
                }
                return value;
            }
        },
        methods: {
            //Lấy toàn bộ sản phẩm có trong POS
            getProducts($pos_id = 0) {
                //this.loading = true;
                //this.$http.get(this.$foodbookConfig.api + 'xpartner/v2/items', {
                this.$http.get(this.$foodbookConfig.wpapi + '/products', {
                    params: {
                        pos_id: $pos_id,
                        //pos_parent: this.$foodbookConfig.pos_name,
                    }
                }).then(response => {
                    if (!response) {
                        this.$toasted.show(this.$t('menu.system_error'), {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                    } else {
                        if (!response.body.error) {

                          let menu = _.sortBy(response.body.data.item_types, ['sort', 'name']);
                            let datas = this.$options.filters.filterProductsActive(response.body.data.items,menu);
                            this.$set(this,'products', this.$options.filters.groupMenu(datas))
                            this.menus = this.$options.filters.filterMenusActive(menu);
                            this.addSelection();
                            sessionStorage.shopTime = JSON.stringify(response.body.data.time_delivery);
                            let mapCenter = {
                                Pos_Longitude: response.body.data.pos.Pos_Longitude,
                                Pos_Latitude:response.body.data.pos.Pos_Latitude
                            };
                            sessionStorage.mapCenter = JSON.stringify(mapCenter);
                        } else {
                            this.$toasted.show(response.body.error.message, {
                                theme: "bubble",
                                position: "top-center",
                                duration: 5000,
                                type: 'error'
                            });
                        }
                    }
                }, response => {
                    //this.loading = false;
                    //this.firstLoading = false;
                });
            },

            //Search Menu
            filterproduct(products) {
                return products.filter(product => {
                    return this.clearText(product.name).includes(this.clearText(this.search))
                })
            },

            //Mo modal product
            openModalProduct(p,index,orderItem){
              this.modalProduct.product = p;
              this.modalProduct.activeId = index;
              this.modalProduct.orderItem = orderItem;
              this.modalProduct.active = true;
            },

            //Clear Text ve khong dau
            clearText(str) {
                str = str.toLowerCase();
                str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g,"a");
                str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g,"e");
                str = str.replace(/ì|í|ị|ỉ|ĩ/g,"i");
                str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g,"o");
                str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g,"u");
                str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g,"y");
                str = str.replace(/đ/g,"d");
                str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g," ");
                str = str.replace(/ + /g," ");
                str = str.trim();
                return str;
            },

            //Update Cart
            updateCart(order,product,index){
                if(index > -1){
                    //Chinh sua gio hang
                    this.$set(this.cart.ordersItem ,index , {'order':order,'product':product});
                }else{
                    this.cart.ordersItem.push({'order':order,'product':product});
                }
                //Update session cart
                this.updateSessionCart();
                this.modalProduct.active = false;

            },
            deleteCartItem(index){
                this.cart.ordersItem.splice(index, 1);
                this.updateSessionCart();
            },
            updateSessionCart(){
                 sessionStorage.cart = JSON.stringify(this.cart);
            },
            gotoCheckout(){
                if(!this.cart.ordersItem.length ){
                    this.$toasted.show(this.$t('menu.Please_select_the_product_you_want_to_buy'), {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                }else{
                    if(!this.$foodbookConfig.userId){
                        this.showModal = true;
                    }else{
                        window.location.replace(this.$foodbookConfig.checkoutpage);
                    }
                }
            },
            handleScroll (event) {
                let scrollPosition = window.scrollY;
                let section = document.querySelectorAll(".groupProducts");
                var sections = {};
                _.forEach(section, function(value, key) {
                    sections[value.id] = value.offsetTop - 40;
                });
                for (let i in sections) {
                    if (sections[i] <= scrollPosition) {
                        document.querySelector('.active').setAttribute('class', ' ');
                        document.querySelector('a[href*=' + i + ']').setAttribute('class', 'active');
                    }
                }
            },

            getURLMenuPage() {
              return this.locale === 'en' ? '/menu-delivery' : '/menu-delivery';
            },
            addSelection() {
              const url = new URL(window.location.href)
              if(url.searchParams.has('selection')) {
                let storeItemId = url.searchParams.get('selection');
                if (storeItemId.length) {
                  // tìm sản phẩm
                  let found = [];
                  _.forOwn(this.products, (cat) => {
                    let f = _.find(cat, {store_item_id: storeItemId})
                    if (f) found.push(f);
                  })

                  if (found.length) {
                    let [item] = found;
                    // món đơn
                    if (item.is_eat_with === 0) {

                      let orderItem = {
                        Discount: 0,
                        Fix: 0,
                        Foc: 0,
                        Item_Id: item.store_item_id,
                        Item_Name: item.name,
                        Item_Type_Id: "",
                        Note: "",
                        Package_Id: "",
                        Price: item.ta_price,
                        Quantity: 1,
                        options: {},
                        plusPrice: 0,
                      }
                      this.updateCart(orderItem,item,-1)
                    } else {
                      this.openModalProduct(item,-1,false)
                    }

                    // bỏ selection, chỉ xử lý 1 lần thôi
                    let page = this.getURLMenuPage();
                    window.history.pushState({},document.title,page);

                  }
                }
              }

            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/components/Menu.vue